import React, { useRef, useState } from 'react';
import { Camera, Image, UploadCloud } from 'lucide-react';
import { Button } from './button';

export default function UploadZone({ onFileSelect, previewUrl, onClear, loading }) {
    const fileInputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files?.[0];
        if (file && file.type.startsWith('image/')) {
            onFileSelect(file);
        }
    };

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    if (previewUrl) {
        return (
            <div className="relative rounded-xl overflow-hidden border-2 border-blue-200 shadow-md group">
                <img
                    src={previewUrl}
                    alt="Preview"
                    className="h-64 w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-4">
                    <Button variant="destructive" size="sm" onClick={(e) => { e.stopPropagation(); onClear(); }}>
                        Remove
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div
            onClick={handleClick}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            className={`
                relative h-40 w-full rounded-xl border-dashed border-2 
                flex flex-col items-center justify-center cursor-pointer transition-all duration-300
                group overflow-hidden bg-gray-50
                ${isDragging ? 'border-blue-500 bg-blue-50 scale-[1.02]' : 'border-gray-300 hover:border-blue-400'}
                ${loading ? 'opacity-50 pointer-events-none' : ''}
            `}
        >
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) onFileSelect(file);
                }}
            />

            <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-purple-50 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />

            <div className="z-10 flex flex-col items-center gap-2 text-gray-500 group-hover:text-blue-600 transition-colors">
                <div className="p-3 bg-white rounded-full shadow-sm group-hover:shadow-md transition-shadow group-hover:scale-110 duration-300">
                    <Camera className="h-8 w-8" />
                </div>
                <div className="font-medium text-sm">
                    Tap to Snap or Upload
                </div>
                <div className="text-xs opacity-70">
                    JPG, PNG, WEBP
                </div>
            </div>
        </div>
    );
}